'use strict';

const Page = require('pages/Page/Page.js');

require('./PageIndex.less');

const IndexHero = require('components/IndexHero/IndexHero');
const IndexCommon = require('components/IndexCommon/IndexCommon');
const IndexCollection = require('components/IndexCollection/IndexCollection');
const IndexLoveDiscs = require('components/IndexLoveDiscs/IndexLoveDiscs');
const IndexNewFriend = require('components/IndexNewFriend/IndexNewFriend');
const IndexConcerts = require('components/IndexConcerts/IndexConcerts');
const IndexAlbums = require('components/IndexAlbums/IndexAlbums');
const IndexThoughts = require('components/IndexThoughts/IndexThoughts');
const IndexCredits = require('components/IndexCredits/IndexCredits');

const ChildViews = [{
    name: 'indexHero',
    Constructor: IndexHero
}, {
    name: 'indexCommon',
    Constructor: IndexCommon
}, {
    name: 'indexCollection',
    Constructor: IndexCollection
}, {
    name: 'indexLoveDiscs',
    Constructor: IndexLoveDiscs
}, {
    name: 'indexNewFriend',
    Constructor: IndexNewFriend
}, {
    name: 'indexConcerts',
    Constructor: IndexConcerts
}, {
    name: 'indexAlbums',
    Constructor: IndexAlbums
}, {
    name: 'indexThoughts',
    Constructor: IndexThoughts
}, {
    name: 'indexCredits',
    Constructor: IndexCredits
}];

module.exports = Page.extend({

    events: {},

    initialize: function (options = {}) {
        Page.prototype.initialize.call(this, options);

        this._initChildViews(ChildViews);
    }
});
